export const settingsMenuCategories = [
    {
        title: 'General',
        items: [
            {
                title: 'Profile',
                route: '/settings/profile',
                icon: 'user',
                minimumAgentRole: 'agent',
                segmentId: 'profile',
                featureFlags: [],
            },
            {
                title: 'Keyboard shortcuts',
                route: '/settings/keyboard-shortcuts',
                icon: 'keyboard',
                minimumAgentRole: 'agent',
                segmentId: 'keyboard',
                featureFlags: [{ name: 'new-keybindings' }],
            },
            {
                title: 'Organization',
                route: '/settings/organization',
                icon: 'building',
                minimumAgentRole: 'admin',
                segmentId: 'organization',
                featureFlags: [],
            },
            {
                title: 'Agents',
                route: '/settings/agents',
                icon: 'headset',
                minimumAgentRole: 'teamlead',
                segmentId: 'agents',
                featureFlags: [],
            },
            {
                title: 'Teams',
                route: '/settings/teams',
                icon: 'team',
                minimumAgentRole: 'teamlead',
                segmentId: 'teams',
                featureFlags: [
                    { name: 'teams-setting-page-and-assigning-teams-to-queues' },
                ],
            },
            {
                title: 'Billing',
                route: '/settings/billing',
                icon: 'credit-card',
                minimumAgentRole: 'admin',
                segmentId: 'billing',
                featureFlags: [],
            },
        ],
    },
    {
        title: 'Channels and flows',
        items: [
            {
                title: 'Queues',
                route: '/settings/queues',
                icon: 'users',
                minimumAgentRole: 'teamlead',
                segmentId: 'queues',
                featureFlags: [],
            },
            {
                title: 'Phone',
                route: '/settings/phone',
                icon: 'phone',
                minimumAgentRole: 'systemadmin',
                segmentId: 'phone',
                featureFlags: [{ name: 'phone-channel' }],
            },
            {
                title: 'Chat',
                route: '/settings/chat',
                icon: 'chat',
                minimumAgentRole: 'systemadmin',
                segmentId: 'chat',
                featureFlags: [{ name: 'widget-chat-channel' }],
            },
            {
                title: 'Email',
                route: '/settings/email',
                icon: 'mail',
                minimumAgentRole: 'systemadmin',
                segmentId: 'email',
                featureFlags: [{ name: 'email-channel' }],
            },
            {
                title: 'Texts',
                route: '/settings/sms',
                icon: 'sms',
                minimumAgentRole: 'admin',
                segmentId: 'sms',
                featureFlags: [{ name: 'sms-channel' }],
            },
            {
                title: 'Third-party messaging',
                route: '/settings/messaging',
                icon: 'messaging-settings',
                minimumAgentRole: 'admin',
                segmentId: 'messaging',
                featureFlags: [
                    { name: 'facebook-messenger-channel' },
                    { name: 'instagram-management' },
                    { name: 'twitter-channel' },
                    { name: 'whatsapp-channel' },
                ],
                featureFlagsStrategy: 'any',
            },
            {
                title: 'Messenger',
                route: '/settings/dixa-messenger',
                icon: 'messenger',
                minimumAgentRole: 'systemadmin',
                segmentId: 'messenger',
                featureFlags: [{ name: 'has-messenger' }],
            },
            {
                title: 'Help Centers',
                route: '/settings/help-centers',
                icon: 'question',
                minimumAgentRole: 'systemadmin',
                segmentId: 'knowledge',
                featureFlags: [
                    {
                        name: 'help-center',
                    },
                ],
            },
        ],
    },
    {
        title: 'Manage',
        items: [
            {
                title: 'Business hours',
                route: '/settings/businesshours',
                icon: 'clock-three',
                minimumAgentRole: 'systemadmin',
                segmentId: 'businesshours',
                featureFlags: [],
            },
            {
                title: 'Tags',
                route: '/settings/tags',
                icon: 'tag',
                minimumAgentRole: 'systemadmin',
                segmentId: 'tags',
                featureFlags: [],
            },
            {
                title: 'Audio files',
                route: '/settings/audio',
                icon: 'volume-up',
                minimumAgentRole: 'systemadmin',
                segmentId: 'audioFiles',
                featureFlags: [],
            },
            {
                title: 'Custom attributes',
                route: '/settings/custom-attributes',
                icon: 'input',
                minimumAgentRole: 'systemadmin',
                segmentId: 'customAttributes',
                featureFlags: [{ name: 'custom-fields' }],
            },
            {
                title: 'Knowledge management',
                route: '/settings/knowledge',
                icon: 'elevio',
                minimumAgentRole: 'agent',
                segmentId: 'knowledge',
                featureFlags: [{ name: 'knowledge-management-nav' }],
            },
            {
                title: 'Templates',
                route: '/settings/templates',
                icon: 'copy',
                minimumAgentRole: 'systemadmin',
                segmentId: 'templates',
                featureFlags: [],
            },
            {
                title: 'Scheduled conversations',
                route: '/settings/scheduled-conversations',
                icon: 'clock',
                minimumAgentRole: 'systemadmin',
                segmentId: 'scheduledConversations',
                featureFlags: [{ name: 'scheduled-conversations' }],
            },
            {
                title: 'Integrations',
                route: '/settings/integrations',
                icon: 'plug',
                minimumAgentRole: 'agent',
                segmentId: 'integrations',
                featureFlags: [],
            },
            {
                title: 'Satisfaction',
                route: '/settings/satisfaction',
                icon: 'smile',
                minimumAgentRole: 'systemadmin',
                segmentId: 'satisfactionChat',
                featureFlags: [
                    { name: 'csat-for-email' },
                    { name: 'csat-for-widget-chat' },
                    { name: 'csat-for-dixa-messenger' },
                ],
                featureFlagsStrategy: 'any',
            },
            {
                title: 'Automations',
                route: '/settings/automations',
                icon: 'merge',
                minimumAgentRole: 'admin',
                segmentId: 'automations',
                featureFlags: [{ name: 'automations' }],
            },
            {
                title: 'Banned users',
                route: '/settings/banned-users',
                icon: 'ban',
                minimumAgentRole: 'admin',
                segmentId: 'bannedUsers',
                featureFlags: [],
            },
            {
                title: 'Export conversations',
                route: '/settings/export-conversations',
                icon: 'download',
                minimumAgentRole: 'admin',
                segmentId: 'exportConversations',
                featureFlags: [{ name: 'export-conversations' }],
            },
        ],
    },
    {
        title: 'About',
        items: [
            {
                title: 'Versions',
                route: '/settings/about',
                icon: 'dixa',
                minimumAgentRole: 'agent',
                segmentId: 'versions',
                featureFlags: [],
            },
        ],
    },
];
